import keyMirror from 'keymirror'
import { ENGINEER_DASHBOARD_ROUTE } from '@/utils/locale'

/**
 * @enum
 */
export const PROVIDE_KEYS = keyMirror({
  ACTIVE_PAGE: null,
})

/**
 * @enum
 */
export const ACTIVE_PAGE = {
  HOME: ENGINEER_DASHBOARD_ROUTE.CMS,
  ENGINEER_DASHBOARD: ENGINEER_DASHBOARD_ROUTE.TMS,
  WORKPERMIT_DASHBOARD: ENGINEER_DASHBOARD_ROUTE.WP,
}
